import {useQuery} from "@urql/preact";
import {useState} from "preact/hooks";
import { useEffectEveryHourOnTheHour } from "./useEffectEveryHourOnTheHour";

const NowPlayingQuery = `
    query {
        nowPlaying {
            startTime: start_time
            track {
                ... on Track {
                    title
                    artist
                    length
                }
                ... on TrackNotRec {
                    title
                    artist
                }
            }
        }
    }
`;

interface NowPlayingInfo {
    nowPlaying: {
        startTime: string;
        track: {
            title: string;
            artist: string;
        };
    }

}

export default function useNowPlaying() {
    const [result, refetch] = useQuery<NowPlayingInfo>({
        query: NowPlayingQuery,
        pollInterval: 15000,
        requestPolicy: 'network-only'
    });
    useEffectEveryHourOnTheHour(refetch);

    const [trackData, setTrackData] = useState<NowPlayingInfo>(undefined);
    const [trackNow, setTrackNow] = useState(true);

    if (!result.data) {
        setTrackData(null);
        setTrackNow(true);
    } else if (result.data.nowPlaying == null) {
        setTrackNow(false)
    } else {
        setTrackNow(true);
        setTrackData(result.data)
    }

    return [trackNow, trackData] as const;
}
